import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

/**
 * Shared persistent stale-layout banner — shown at the top of a form once the
 * user has dismissed the reload-prompt modal. Signals that the form layout is
 * known to be out of sync with upstream scope until the page is reloaded.
 *
 * Pair with ReloadPromptComponent (modal). Plain HTML + Tailwind + PrimeNG
 * ButtonModule — deliberately NOT backed by PrimeNG ConfirmDialog so the
 * MBRS custom-popup look-and-feel stays consistent.
 */
@Component({
  selector: 'app-reload-banner',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './reload-banner.component.html',
  styleUrls: ['./reload-banner.component.css'],
})
export class ReloadBannerComponent {
  @Input() visible = false;
  @Input() message =
    'Filing scope changed in another tab. Reload to see the updated form layout.';

  @Output() reload = new EventEmitter<void>();

  onReloadClick(): void {
    this.reload.emit();
  }
}
